export class ImageSingleRegistDataModel {
    // JPGファイル更新フラグ
    public static JPG_UPDATE_FLG_OFF: string = <string>'0';					// 更新否
    public static JPG_UPDATE_FLG_ON: string = <string>'1';					// 更新要

    public imageFilePNG: string = <string>'';            // 画像ファイル(PNG)
    public imageFileEPS: string = <string>'';            // 画像ファイル(EPS)
    public startOrderCode: string = <string>'';          // 使用開始受注コード
    public endOrderCode: string = <string>'';            // 使用終了受注コード
    public endOrderNothing: boolean = <boolean>true;      // 無期限チェック
    public endOrderEqual: boolean = <boolean>false;       // 今回のみチェック
    public imageBelongID: string = <string>'';           // 画像所属
    public imageKind: string = <string>'';               // 画像種類
    public imageType: string = <string>'';               // 画像種別
    public processInstruct: string = <string>'';         // 加工指示
    public cookingExPublish: string = <string>'0';       // 調理例掲載区分
    public billingTargetDiv: string = <string>'1';       // 請求対象区分
    public pCode: string = <string>'';                   // Ｐコード
    public sampleOrderingCode: string = <string>'';      // サンプル発注先コード
    public billingCode: string = <string>'';             // 請求先コード
    public cookingDiv: string = <string>'';              // 料理分類
    public cookingName: string = <string>'';             // 料理名
    public materialName: string = <string>'';            // 材料名
    public keyWord: string = <string>'';                 // キーワード
    public eventID: string = <string>'';                 // 季節・催事
    public remarks: string = <string>'';                 // 備考
    public photoContentsDiv: string = <string>'';        // 撮影内容区分
    public photoInstructContents: string = <string>'';   // 撮影指示内容
    public photoSchedule: string = <string>'';           // 撮影予定日
    public photoStudioID: string = <string>'';           // 撮影場所ＩＤ

    public imageId: string = <string>'';
    public imageName: string = <string>'';
    public imageFileName: string = <string>'';
    public imageNameBranch: string = <string>'';

    public jpgUpdateFlg: string = <string>'';			// JPGファイル更新フラグ(0:更新否、1:更新要)

    public textCaption: string = <string>'';				// 画像キャプション

}